<template>
    <BreadCrumb PageTitle="Ajouter une Zone" />
    <AddModalZone />
</template>

<script lang="ts">
import { defineComponent } from "vue";
import BreadCrumb from "../../components/Common/BreadCrumb.vue";
import AddModalZone from "@/components/Zone/AddModalZone.vue";

export default defineComponent({
    name: "AddZonePage",
    components: {
        BreadCrumb,
        AddModalZone,
    },
});
</script>